<template>
  <div>
    <router-view />

    <div class="button-view no-print" :class="scrolled ? 'mover' : null">
      <botao-favoritos />
      <botao-tabela-de-precos v-if="getCanal"/>
    </div>
  </div>
</template>

<script>
import env from '@/config/env';
import { mapGetters, mapActions } from 'vuex';
import BotaoNotificacao from '@/components/BotaoNotificacao';
import BotaoFavoritos from '@/components/BotaoFavoritos';
import BotaoTabelaDePrecos from '@/components/BotaoTabelaDePrecos.vue';
import BotaoRankingLojas from '@/components/BotaoRankingLojas.vue';
import Error from '@/components/ErrorBox/Error.vue';

export default {
  name: 'RouterRevista',
  data: () => ({
    notify: true,
    ownStore: false,
    // State Div
    janela: window.pageYOffset,
    scrolled: false,
  }),
  components: {
    BotaoNotificacao,
    BotaoTabelaDePrecos,
    BotaoRankingLojas,
    BotaoFavoritos,
  },
  methods: {
    ...mapActions({
      authenticate: 'auth/authenticate',
      setUF: 'uf/setUF',
      addUF: 'vcUser/addUF',
      changeUF: 'vcUser/changeUF',
      getImportacao: 'vcTabela/getImportacao',
      clearImportacao: 'vcTabela/clearImportacao',
      getCategoria: 'categoria/createCategorias',
    }),
    async loadAllResources() {
      // Get All UFS
      await this.setUF();
      // Verifica UF já existe
      const vcUF = window.localStorage.getItem('@vivo.consulta:UF');
      const roUF = window.localStorage.getItem('revista.uf');
      const localUF =
        (await vcUF) && vcUF !== 'undefined'
          ? vcUF
          : roUF && roUF !== 'undefined'
          ? roUF
          : 'RJ';
      // Adicionar a UF do Usuário na Store
      const ufId = await this.addUF(localUF);
      // Get Tabela de Importação
      await this.getImportacao(ufId);
    },
    // State Div
    rolagem() {
      this.scrolled = window.scrollY > 200;
    },

    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },
  },
  computed: {
    ...mapGetters({
      idle: 'idle/status',
    }),
    getCanal() {
      const canal = localStorage.getItem('revista.canal');
      return canal != 7;
    }
  },
  created() {
    /**
     * Event Scroll (Ricardo)
     */
    window.addEventListener('scroll', this.handleScroll);
    document.body.addEventListener('scroll', this.rolagem);

    // create variables for Window
    this.authenticate();

    this.loadAllResources();

    // Verify Channel User
    if (env.revista.canal === 5) {
      this.ownStore = true;
    }

    this.$store.subscribeAction(action => {
      switch (action.type) {
        case 'vcUser/changeUF':
          this.loadAllResources();
      }
    });
  },
  mounted() {
    this.$store.watch(
      (state, getters) => getters['idle/status'],
      after => {
        if (after) {
          this.$store.dispatch('auth/logout');
          this.$router.push('/login');
        }
      },
    );

    this.$nextTick(() => {
      if (this.$store.state.auth.isAuth) {
        this.getCategoria();
      } else {
        this.$router.push('/login');
      }
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.removeEventListener('scroll', this.rolagem);
  },
  watch: {
    $route(after) {
      this.notify = after.name !== 'login';
    },
  },
};
</script>

<style lang="scss">
.button-view {
  z-index: 99;
  bottom: 40px;
  position: fixed;
  right: 20px;
  transition: all 0.2s linear;
}
.mover {
  bottom: 85px;
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .button-view {
    font-size: 7px;
    line-height: 7px;
    width: 40px;
    height: 40px;
    bottom: 125px;
    right: 10px;
    padding-bottom: 0;

    &:hover {
      transform: none;
    }
  }
  & .mover {
    bottom: 160px;
  }
}
</style>
